import { GIVONIC } from '../../styles/fonts'
import * as S from './PlanPrices.styles'

const toCurrencyFormat = (num: number) => Number(Number(num).toFixed(0)).toLocaleString('id-ID')

export type PlanPricesProps = {
  idr: number
  idrFontFamily?: string
  idrFontSize?: number
}

export default function PlanPrices({
  idr,
  idrFontFamily = GIVONIC.bold,
  idrFontSize = 18
}: PlanPricesProps) {
  return (
    <S.Container>
      <S.IdrPrice $fontFamily={idrFontFamily} $fontSize={idrFontSize}>
        Rp<span>{toCurrencyFormat(idr)}</span>
      </S.IdrPrice>
    </S.Container>
  )
}
